
import styled from "@emotion/styled";
import Page from 'components/layout/Page';

import { ContextContainer, BigText, Button } from 'components/ui';

const Elem:React.FC<any> = () => {
  return (
    <Page disable={false}>
      <Container>
        <ContextContainer className="Title">
          <InfoBigText>회원 탈퇴</InfoBigText>
        </ContextContainer>
        <SecondContainer>
          <ButtonWrapper>
            <WithdrawalButton layoutVariant='contained' variant='default' expand>회원 탈퇴</WithdrawalButton>
          </ButtonWrapper>
        </SecondContainer>
      </Container>
    </Page>
  );
};

export default Elem;

const Container = styled.div`
  width: 900px;
  height: 700px;
  min-height: 0vh;


  display: flex;
  flex-direction: column;
`

const InfoBigText = styled(BigText)`
  font-size: 23px;
  font-weight: 700;
  margin-top: 16px;
`

const SecondContainer = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
`

const ButtonWrapper =styled.div`
  width: 304px;
  height: 56px;
  margin: 297px auto;
  background-color: blue;
`
const WithdrawalButton = styled(Button)`
  font-family: 'Pretendard';
  font-style: normal;
  font-weight: 400;
  font-size: 20px;
  line-height: 26px;
  color: var(--grey);
  border-color: var(--grey);
`